export default __webpack_public_path__ + "static/media/0x7e9928afe96fefb820b85b4ce6597b8f660fe4f4.72e24e3c.webp";